const ARROW_PATHS = {
  default: 'M32.2979 20L9.67578 40.7373L8.32422 39.2627L29.3379 20L8.32422 0.737305L9.67578 -0.737305L32.2979 20Z',
};

document.addEventListener('DOMContentLoaded', function () {
  // スライド要素を手動でシャッフル
  const slideContainer = document.querySelector('.splide.l-mv_slide .splide__list');
  if (slideContainer) {
    const slides = Array.from(slideContainer.children);
    if (slides.length > 1) {
      for (let i = slides.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [slides[i], slides[j]] = [slides[j], slides[i]];
      }
      slides.forEach((slide) => slideContainer.appendChild(slide));
    }
  }

  const slideCount = slideContainer ? slideContainer.children.length : 0;
  const isSingle = slideCount <= 1;

  const mvSplide = new Splide('.splide.l-mv_slide', {
    type: isSingle ? 'slide' : 'loop', // 1枚時はクローンなし
    autoplay: true,
    speed: 1500,
    interval: 6000,
    perPage: 1,
    heightRatio: 0.5625,
    gap: isSingle ? '0rem' : '1.8rem', // 1枚時はギャップ0
    arrowPath: ARROW_PATHS.default,
    arrows: !isSingle, // 1枚時は矢印非表示
    drag: !isSingle, // 1枚時はドラッグ不可
    keyboard: !isSingle, // 1枚時はキーボード不可
    breakpoints: {
      750: {
        heightRatio: 1.3,
        gap: isSingle ? '0rem' : '0.8rem', // SP時もギャップ0
      },
    },
  });
  mvSplide.mount();

  const pickupSplide = new Splide('.splide.l-pickupSct_slide', {
    type: 'loop',
    autoplay: true,
    speed: 1500,
    interval: 4000,
    perPage: 3,
    perMove: 3,
    gap: '2.4rem',
    pagination: false,
    arrowPath: ARROW_PATHS.default,
    breakpoints: {
      750: {
        perPage: 2,
        perMove: 2,
        gap: '1.5rem',
      },
    },
  });
  pickupSplide.mount();
  
});
